<template>
	<div style="width: 100%;height: 100%;">
		<div style="width:98%;margin-left: 1%;margin-top:1.5%;height:95%;background-color: white;box-shadow:#e0e0e0 5px 5px 10px;">
			<div style="width:95%;height:96%;padding:2%;display: flex;flex-direction: column;">
			
				<div style="width:100%;display: flex;flex-direction: row;align-items: center;height:3vh;margin-bottom: 2vh;"
				
				>	
                    <div style="height: 35px;width:120px;border-radius: 5px;display: flex;align-items: center;justify-content: center;margin-right: 10px;"
                    :style="{backgroundColor:type==0?'#3c9cff':'#d9ecff',color:type==0?'white':'#409eff'}" @click="show=true"
                    >
                        {{ "添加礼物信息" }}
                    </div>
				</div>

				<div style="height: auto;flex:1;" >
				<el-table
					height="80vh"
				    :data="list"
					border
				    style="width: 100%"
					>
                    <el-table-column
				      prop="title"
				      label="标题"
				      >
				    </el-table-column>
                    <el-table-column
				      prop="shipnum"
				      label="当前舰长数"
				      >
				    </el-table-column>
                    <el-table-column
				      label="备注"
				      width="500">
                        <template slot-scope="scope">
							<div>{{ (scope.row.notice=='None'||scope.row.notice==null||scope.row.notice=='')?'无':scope.row.notice }}</div>
					    </template>
				    </el-table-column>
					<el-table-column
				      label="发货状态"
				      width="100">
                        <template slot-scope="scope">
							<div v-if="scope.row.status==0">{{'待结算'}}</div>
                            <div v-if="scope.row.status==1">{{'未发货'}}</div>
                            <div v-if="scope.row.status==2">{{'已发货'}}</div>
					    </template>
				    </el-table-column>
                    <el-table-column
					      fixed="right"
					      label="操作"
						  width="180"
					      >
					      <template slot-scope="scope">
                            <el-button @click="updategift1(scope.row)" type="text" size="small">编辑</el-button>
							<el-button @click="deletevideo(scope.row)" type="text" size="small">删除</el-button>
					      </template>
					</el-table-column>
				  </el-table>
				</div>
			</div>
		</div>
        
        <el-dialog
        title="添加舰长礼物"
        :visible.sync="show"
        width="30%;"
        style="z-index: 9999;"
        >

            <el-form ref="newgift" :model="newgift" label-width="80px">
                <el-form-item label="舰礼标题">
                    <el-input v-model="newgift.title"></el-input>
                </el-form-item>
                <el-form-item label="舰长礼物">
                    <el-input type="textarea" v-model="newgift.gift1" placeholder="每个礼物用回车换行"></el-input>
                </el-form-item>
                <el-form-item label="提督礼物">
                    <el-input type="textarea" v-model="newgift.gift2" placeholder="每个礼物用回车换行"></el-input>
                </el-form-item>
                <el-form-item label="总督礼物">
                    <el-input type="textarea" v-model="newgift.gift3" placeholder="每个礼物用回车换行"></el-input>
                </el-form-item>
                <el-form-item label="50舰礼物">
                    <el-input type="textarea" v-model="newgift.gift4" placeholder="每个礼物用回车换行，没有则留空"></el-input>
                </el-form-item>
                <el-form-item label="100舰礼物">
                    <el-input type="textarea" v-model="newgift.gift5" placeholder="每个礼物用回车换行，没有则留空"></el-input>
                </el-form-item>
                <el-form-item label="150舰礼物">
                    <el-input type="textarea" v-model="newgift.gift6" placeholder="每个礼物用回车换行，没有则留空"></el-input>
                </el-form-item>
                <el-form-item label="200舰礼物">
                    <el-input type="textarea" v-model="newgift.gift7" placeholder="每个礼物用回车换行，没有则留空"></el-input>
                </el-form-item>
                 <el-form-item label="250舰礼物">
                    <el-input type="textarea" v-model="newgift.gift8" placeholder="每个礼物用回车换行，没有则留空"></el-input>
                </el-form-item>
                <el-form-item label="300舰礼物">
                    <el-input type="textarea" v-model="newgift.gift9" placeholder="每个礼物用回车换行，没有则留空"></el-input>
                </el-form-item>
                <el-form-item label="备注信息">
                    <el-input type="textarea" v-model="newgift.notice"></el-input>
                </el-form-item>
                <el-form-item label="当前上舰">
                    <el-input type="number" v-model="newgift.shipnum"></el-input>
                </el-form-item label='礼物图鉴'>
                    <el-upload
                    class="upload-demo"
                    action="/api/admin/uploadimage"  
                    list-type="picture"  
                    :file-list="filelist" 
                    :on-success="handleSuccess"  
                    :on-remove="handleRemove"  
                    :limit="2" 
                    :data="{type:1}"
                    accept="image/jpeg,image/png,image/gif" 
                    >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">
                        支持jpg、png、gif格式，单张不超过5MB，最多上传5张
                    </div>
                    </el-upload>
                <el-form-item label="发货状态">
                    <el-radio-group v-model="newgift.status">
                        <el-radio :label="2">已发货</el-radio>
                        <el-radio :label="1">未发货</el-radio>
                        <el-radio :label="0">待结算</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onsubmit">立即添加</el-button>
                    <el-button @click="show=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog
        title="修改舰长礼物"
        :visible.sync="show1"
        width="30%;"
        style="z-index: 9999;"
        >

            <el-form ref="newgift" :model="updategift" label-width="80px">
                <el-form-item label="舰礼标题">
                    <el-input v-model="updategift.title"></el-input>
                </el-form-item>
                <el-form-item label="舰长礼物">
                    <el-input type="textarea" v-model="updategift.gift1" placeholder="每个礼物用回车换行"></el-input>
                </el-form-item>
                <el-form-item label="提督礼物">
                    <el-input type="textarea" v-model="updategift.gift2" placeholder="每个礼物用回车换行"></el-input>
                </el-form-item>
                <el-form-item label="总督礼物">
                    <el-input type="textarea" v-model="updategift.gift3" placeholder="每个礼物用回车换行"></el-input>
                </el-form-item>
                <el-form-item label="50舰礼物">
                    <el-input type="textarea" v-model="updategift.gift4" placeholder="每个礼物用回车换行，没有则留空"></el-input>
                </el-form-item>
                <el-form-item label="100舰礼物">
                    <el-input type="textarea" v-model="updategift.gift5" placeholder="每个礼物用回车换行，没有则留空"></el-input>
                </el-form-item>
                <el-form-item label="150舰礼物">
                    <el-input type="textarea" v-model="updategift.gift6" placeholder="每个礼物用回车换行，没有则留空"></el-input>
                </el-form-item>
                <el-form-item label="200舰礼物">
                    <el-input type="textarea" v-model="updategift.gift7" placeholder="每个礼物用回车换行，没有则留空"></el-input>
                </el-form-item>
                 <el-form-item label="250舰礼物">
                    <el-input type="textarea" v-model="updategift.gift8" placeholder="每个礼物用回车换行，没有则留空"></el-input>
                </el-form-item>
                <el-form-item label="300舰礼物">
                    <el-input type="textarea" v-model="updategift.gift9" placeholder="每个礼物用回车换行，没有则留空"></el-input>
                </el-form-item>
                <el-form-item label="备注信息">
                    <el-input type="textarea" v-model="updategift.notice" ></el-input>
                </el-form-item>
                <el-form-item label="当前上舰">
                    <el-input type="number" v-model="updategift.shipnum"></el-input>
                </el-form-item>
                <el-form-item label="礼物图示">
                    <el-upload
                    class="upload-demo"
                    action="/api/admin/uploadimage"  
                    list-type="picture"  
                    :file-list="filelist1" 
                    :on-success="handleSuccess1"  
                    :on-remove="handleRemove1"  
                    :limit="2" 
                    :data="{type:1}"
                    accept="image/jpeg,image/png,image/gif" 
                    >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">
                        支持jpg、png、gif格式，单张不超过5MB，最多上传5张
                    </div>
                    </el-upload>

                </el-form-item>
                 <el-form-item label="发货状态">
                    <el-radio-group v-model="updategift.status">
                        <el-radio :label="2">已发货</el-radio>
                        <el-radio :label="1">未发货</el-radio>
                        <el-radio :label="0">待结算</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onchange">保存</el-button>
                    <el-button @click="show1=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
		
		
		
	</div>
</template>

<script>
import {post,get} from "../axios/request.js"
export default {
  name:"order",
  data() {
    return {
       filelist:[],
       filelist1:[],
       list:[],
       type:0,
       show:false,
       show1:false,
       newgift:{
        title:'',
        shipnum:0,
        notice:"",
        gift1:"",
        gift2:"",
        gift3:"",
        gift4:"",
        gift5:"",
        gift6:"",
        gift7:"",
        gift8:null,
        gift9:null,
        status:0,
        filelist:[],
       },
       updategift:{
        title:'',
        shipnum:0,
        notice:"",
        gift1:"",
        gift2:"",
        gift3:"",
        gift4:"",
        gift5:"",
        gift6:"",
        gift7:"",
        gift8:null,
        gift9:null,
        status:0,
        filelist:[],
       }
    }
  },
  mounted() {
	this.getmore();
  },
  methods: {
    handleSuccess(e){
        this.newgift.filelist.push(e.url)
    },
    handleSuccess1(e){
        this.updategift.filelist.push(e.url)
    },
    handleRemove(e){
        var name = e.response.url;
        this.newgift.splice(this.newgift.indexOf(name),1)
    },
    handleRemove1(e){
        var name = e.response.url;
        this.updategift.splice(this.updategift.indexOf(name),1)
    },
	getmore(){
		post("/api/getgift",{}).then((res)=>{
			if(res.data.code==1001){
                this.list=res.data.data.reverse();
            }
		})
	},
    updategift1(e){
        this.updategift=e;
        if(this.updategift.gift4=='None')this.updategift.gift4=''
        if(this.updategift.gift5=='None')this.updategift.gift5=''
        if(this.updategift.gift6=='None')this.updategift.gift6=''
        if(this.updategift.gift7=='None')this.updategift.gift7=''
        this.filelist1=[]
        if(e.url!=null&&e.url!=''&&e.url!='None'){
        this.updategift.filelist=e.url.split(";");
        var data=this.updategift.filelist
        for(var x=0;x<data.length;x++){
            this.filelist1.push({
                name:"图示"+(x+1),
                url:data[x]
            })
        }
        }
        this.show1=true
    },
    onchange(){
        if(this.updategift.title==''){
            this.$message.error("请填写舰礼标题")
            return;
        }
        if(this.updategift.gift1==''){
            this.$message.error("请填写舰长礼物")
            return;
        }
        if(this.updategift.gift2==''){
            this.$message.error("请填写提督礼物")
            return;
        }
        if(this.updategift.gift3==''){
            this.$message.error("请填写总督礼物")
            return;
        }
        if(this.updategift.filelist.length==0)this.updategift.url=null;
        if(this.updategift.filelist.length==1)this.updategift.url=this.updategift.filelist[0];
        if(this.updategift.filelist.length==2)this.updategift.url=this.updategift.filelist[0]+';'+this.updategift.filelist[1]
        post("/api/admin/updategift",this.updategift).then((res)=>{
            if(res.data.code==1001){
                this.$notify({
                    title: '提交成功',
                    message: '已修改'+this.updategift.title,
                    type: 'success'
                });
                this.show1=false;
                this.updategift={
                    title:'',
                    shipnum:0,
                    notice:"",
                    gift1:"",
                    gift2:"",
                    gift3:"",
                    gift4:"",
                    gift5:"",
                    gift6:"",
                    gift7:"",
                    gift8:null,
                    gift9:null,
                    status:0,
                }
                this.getmore()
            }else{
                 this.$notify({
                    title: '系统错误',
                    type: 'error'
                });
            }
        })
    },
    onsubmit(){
        if(this.newgift.title==''){
            this.$message.error("请填写舰礼标题")
            return;
        }
        if(this.newgift.gift1==''){
            this.$message.error("请填写舰长礼物")
            return;
        }
        if(this.newgift.gift2==''){
            this.$message.error("请填写提督礼物")
            return;
        }
        if(this.newgift.gift3==''){
            this.$message.error("请填写总督礼物")
            return;
        }
        if(this.newgift.filelist.length==0)this.newgift.url=null;
        if(this.newgift.filelist.length==1)this.newgift.url=this.newgift.filelist[0];
        if(this.newgift.filelist.length==2)this.newgift.url=this.newgift.filelist[0]+';'+this.newgift.filelist[1]
        post("/api/admin/newgift",this.newgift).then((res)=>{
            if(res.data.code==1001){
                this.$notify({
                    title: '提交成功',
                    message: '已添加'+this.newgift.title,
                    type: 'success'
                });
                this.show=false;
                this.newgift={
                    title:'',
                    shipnum:0,
                    notice:"",
                    gift1:"",
                    gift2:"",
                    gift3:"",
                    gift4:"",
                    gift5:"",
                    gift6:"",
                    gift7:"",
                    gift8:null,
                    gift9:null,
                    status:0,
                    filelist:[],
                    url:null
                }
                this.filelist=[]
                this.getmore()
            }else{
                 this.$notify({
                    title: '系统错误',
                    type: 'error'
                });
            }
        })
    },
    deletevideo(e){
        this.$confirm('是否删除舰礼:'+e.title, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          post("/api/admin/deletegift",{id:e.id}).then((res)=>{
			if(res.data.code==1001){
                this.$notify({
                    title: '删除成功',
                    type: 'success'
                });
                this.getmore()
            }else{
                this.$notify({
                    title: '错误',
                    video: '未知的系统错误',
                    type: 'error'
                });
            }
		})
        }).catch(() => {
                
        });
        
    }
  }
}
</script>
<style scoped>
::v-deep .isdisabled  {
	background-color: white;
}
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
</style>